export const FLOORS = [
    { name: 'Subsol', value: 0 },
    { name: 'Demisol', value: 1 },
    { name: 'Parter', value: 2 },
    { name: 'Mansardă', value: 3 },
    { name: 'Nivel 1', value: 4 },
    { name: 'Nivel 2', value: 5 },
    { name: 'Nivel 3', value: 6 },
    { name: 'Nivel 4', value: 7 },
    { name: 'Nivel 5', value: 8 },
    { name: 'Nivel 6', value: 9 },
    { name: 'Nivel 7', value: 10 },
    { name: 'Nivel 8', value: 11 },
    { name: 'Nivel 9', value: 12 },
    { name: 'Nivel 10', value: 13 },
    { name: 'Nivel 11', value: 14 },
    { name: 'Nivel 12', value: 15 },
    { name: 'Nivel 13', value: 16 },
    { name: 'Nivel 14', value: 17 },
    { name: 'Nivel 15', value: 18 },
    { name: 'Nivel 16', value: 19 },
  ];
  
  export const FLOOR_MAP = Object.fromEntries(FLOORS.map(f => [f.value, f.name]));